import {defineConfig} from '../config'
import { authHeader } from '../helpers';
import { utilsService } from './utils'
const {handleResponse} = utilsService

export const geoService = {
    getApiPath,
    getLocationByAddress,
    getProvincesByRegion,
    getMunicipalitiesByProvince,
    getZipCodesByMunicipalityIstatCode,
    getLocationsByCoordinates,
};

const {apiUrl, apiVer} = defineConfig.GEO_SERVICE;

function getApiPath(){
  return apiUrl + "/" + apiVer + "/georegistry";
}

function getLocationByAddress(address) {
  const url = getApiPath() + "/all/location/" + address;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getProvincesByRegion(region) {
  const url = getApiPath() + "/all/province/" + region;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getMunicipalitiesByProvince(province) {
  const url = getApiPath() + "/all/municipality/" + province;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getZipCodesByMunicipalityIstatCode(istatCode) {
  const url = getApiPath() + "/all/zipCode/" + istatCode;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getLocationsByCoordinates(lat, long) {
  const url = getApiPath() + "/all/location/" + lat + "/" + long;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}
